import axios from 'axios';

import routes from 'app/routes';

const prepareData = (data) => ({
  ...data,
  sessionsTopics: data.sessionsTopics.map((item) => ({
    position: item.position,
    topic_id: item.topic.id,
  })),
});

export default {
  load: (dispatch, enterpriseId, afterCallback = () => {}) => {
    axios
      .get(routes.api.enterprises.templates(enterpriseId), { params: { with_steps: true } })
      .then((resp) => {
        dispatch({ type: 'LOAD', templates: resp.data.data });
        afterCallback();
      });
  },

  show: (templateId, afterCallback = () => {}) => {
    axios
      .get(routes.api.managers.programs.show(templateId))
      .then((resp) => {
        afterCallback(resp.data.data);
      });
  },

  new: (dispatch, templateId, afterCallback = () => {}) => {
    axios
      .get(routes.api.managers.programs.new, { params: { template_id: templateId } })
      .then((resp) => {
        afterCallback(resp.data.data);
      });
  },

  create: (dispatch, data, afterCallback = () => {}) => {
    axios
      .post(routes.api.managers.programs.create, { ...prepareData(data) })
      .then((_resp) => {
        afterCallback();
      });
  },

  update: (dispatch, templateId, data, afterCallback = () => {}) => {
    axios
      .put(routes.api.managers.programs.update(templateId), { ...prepareData(data) })
      .then((_resp) => {
        afterCallback();
      });
  },

  delete: (dispatch, templateId) => {
    axios
      .delete(routes.api.managers.programs.destroy(templateId))
      .then((_resp) => {
        dispatch({ type: 'DELETE', templateId });
      });
  },

  clone: (dispatch, templateId) => {
    axios
      .get(routes.api.managers.programs.clone(templateId))
      .then((resp) => {
        dispatch({ type: 'CLONE', template: resp.data.data });
      });
  },
};
